import { type RefObject } from "react";
import { useTranslation } from "react-i18next";
import { DocumentToc } from "../../components/markdown/DocumentToc";

/**
 * Contents rail for a help article.
 *
 * The behaviour lives in DocumentToc, which the legal documents share. This
 * keeps the help centre's own defaults — h2 and h3, labelled from the heading
 * text — so an article's rail is unchanged.
 */
export function HelpToc({
  articleRef,
  slug,
}: {
  articleRef: RefObject<HTMLDivElement | null>;
  slug: string;
}) {
  const { t } = useTranslation();

  return (
    <DocumentToc
      key={slug}
      containerRef={articleRef}
      title={t("help:article.onThisPage")}
    />
  );
}
